import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-centre',
  templateUrl: './notification-centre.component.html',
  styleUrls: ['./notification-centre.component.scss']
})
export class NotificationCentreComponent implements OnInit {
  titleSection = 'Notification Centre'
  NCInfo = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

  NCCardDeck = [
    {
      cardTitle: 'Items to review',
      cardCircle: 10,
      cardText: 'Here you can find items in your plan that are due for review.',
      cardVersoTitle: 'Card title',
      cardVersoText: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      cardTitle: 'Items to review',
      cardCircle: 10,
      cardText: 'Here you can find items in your plan that are due for review.',
      cardVersoTitle: 'Card title',
      cardVersoText: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    },
    {
      cardTitle: 'Items to review',
      cardCircle: 10,
      cardText: 'Here you can find items in your plan that are due for review.',
      cardVersoTitle: 'Card title',
      cardVersoText: "Some quick example text to build on the card title and make up the bulk of the card's content.",
    }
  ]

  NCCardData = [
    {
      cardData: 'Lorem Ipsum',
      cardMenuBtn: 'Review'
    },
    {
      cardData: 'Lorem Ipsum',
      cardMenuBtn: 'Review'
    },
    {
      cardData: 'Lorem Ipsum',
      cardMenuBtn: 'Review'
    },
  ]
  constructor() { }

  ngOnInit() {
  }

}
